var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr } from '@ember-data/model';
import { computed } from '@ember/object';
export const DoorDashWaitListKey = 'DOORDASH_BETA';
export const UberEatsWaitListKey = 'UBEREATS_BETA';
export const GrubhubWaitListKey = 'GRUBHUB_BETA';
export const ThanxWaitListKey = 'THANX_BETA';
let Waitlist = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('json-or-value'), _dec4 = attr('boolean'), _dec5 = attr('date'), _dec6 = attr('date'), _dec7 = attr('date'), _dec8 = computed('enabled'), _dec9 = computed('enabled'), _class = class Waitlist extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantId", _descriptor, this);
    _initializerDefineProperty(this, "key", _descriptor2, this);
    _initializerDefineProperty(this, "value", _descriptor3, this);
    _initializerDefineProperty(this, "enabled", _descriptor4, this);
    _initializerDefineProperty(this, "createdAt", _descriptor5, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor6, this);
    _initializerDefineProperty(this, "deletedAt", _descriptor7, this);
  }
  get isEnabled() {
    return this.enabled;
  }
  get isDisabled() {
    return !this.enabled;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "key", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "value", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "enabled", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "deletedAt", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isEnabled", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "isEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDisabled", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "isDisabled"), _class.prototype), _class);
export { Waitlist as default };